var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg038Cut1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.664,471.583h-49.898c-11.024,0-19.959,8.936-19.959,19.959c0,11.023,8.936,19.959,19.959,19.959h49.898 c11.024,0,19.959-8.936,19.959-19.959C227.623,480.519,218.688,471.583,207.664,471.583z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.323,471.583h-49.898c-11.024,0-19.959,8.936-19.959,19.959c0,11.023,8.936,19.959,19.959,19.959h49.898 c11.024,0,19.959-8.936,19.959-19.959C373.283,480.519,364.347,471.583,353.323,471.583z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.963,471.583c-11.579,0-21-9.421-21-21.001c0-11.024-8.936-19.959-19.959-19.959c-11.023,0-19.959,8.936-19.959,19.959 c0,33.592,27.327,60.92,60.919,60.92c11.023,0,19.959-8.936,19.959-19.959C80.922,480.519,71.986,471.583,60.963,471.583z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.043,430.622c-11.024,0-19.959,8.936-19.959,19.959c0,11.58-9.42,21.001-21,21.001 c-11.023,0-19.959,8.936-19.959,19.959c0,11.023,8.936,19.959,19.959,19.959c33.592,0,60.919-27.328,60.919-60.92 C511.002,439.558,502.066,430.622,491.043,430.622z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.664,0.498h-49.898c-11.024,0-19.959,8.936-19.959,19.959s8.936,19.959,19.959,19.959h49.898 c11.024,0,19.959-8.936,19.959-19.959S218.688,0.498,207.664,0.498z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.323,0.498h-49.898c-11.024,0-19.959,8.936-19.959,19.959s8.936,19.959,19.959,19.959h49.898 c11.024,0,19.959-8.936,19.959-19.959S364.347,0.498,353.323,0.498z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.963,0.498c-33.592,0-60.92,27.328-60.92,60.92c0,11.024,8.936,19.959,19.959,19.959s19.959-8.936,19.96-19.959 c0-11.58,9.42-21.001,21-21.001c11.023,0,19.959-8.936,19.959-19.959S71.986,0.498,60.963,0.498z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.083,0.498c-11.023,0-19.959,8.936-19.959,19.959s8.936,19.959,19.959,19.959c11.579,0,21,9.421,21,21.001 c0,11.024,8.936,19.959,19.959,19.959c11.023,0,19.959-8.936,19.959-19.959C511.002,27.827,483.675,0.498,450.083,0.498z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.959,288.911C8.936,288.911,0,297.847,0,308.87v49.898c0,11.024,8.936,19.959,19.959,19.959 s19.959-8.936,19.959-19.959V308.87C39.919,297.847,30.983,288.911,19.959,288.911z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.959,143.252C8.936,143.252,0,152.188,0,163.211v49.898c0,11.024,8.936,19.959,19.959,19.959 s19.959-8.936,19.959-19.959v-49.898C39.919,152.188,30.983,143.252,19.959,143.252z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.041,288.911c-11.023,0-19.959,8.936-19.959,19.959v49.898c0,11.024,8.936,19.959,19.959,19.959 c11.024,0,19.959-8.936,19.959-19.959V308.87C512,297.847,503.064,288.911,492.041,288.911z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.041,143.252c-11.023,0-19.959,8.936-19.959,19.959v49.898c0,11.024,8.936,19.959,19.959,19.959 c11.024,0,19.959-8.936,19.959-19.959v-49.898C512,152.188,503.064,143.252,492.041,143.252z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg038Cut1);
export default __webpack_public_path__ + "static/media/038-cut-1.fe0c65b27450a1479de7a3967d89b61f.svg";
export { ForwardRef as ReactComponent };